import { useAuthStore } from '~/plugins/auth';

export const useAuthUser = () => {
    const { user } = storeToRefs(useAuthStore());

    return {
        loggedUser: user,
    };
};
